export default "__VITE_ASSET__Zg$FcDqL__"